import React, { useEffect } from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Button } from '../../../../UI/Elements';
import { useDrawer } from 'utils/recoil/drawer';

export const LocationDetail = ({
  undoFlyToStore,
  setActiveStoreDetail,
  currentStore,
  map,
  directionLabel,
  allVendorsLabel,
  isWindowSmallSize,
}) => {
  const drawer = useDrawer();
  const handleDirectionsClick = () => {
    if (typeof window !== 'undefined') {
      window.open(
        `https://maps.google.com/?saddr=Current+Location&daddr=${currentStore.geometry.coordinates[1]},${currentStore.geometry.coordinates[0]}`,
        '_blank'
      );
    }
  };

  const handleAllStoresClick = () => {
    setActiveStoreDetail(false);
    undoFlyToStore(map, currentStore);
  };

  const handleOnClose = () => {
    setActiveStoreDetail(false);
    undoFlyToStore(map, currentStore);
    if (typeof window !== 'undefined') {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    if (currentStore && isWindowSmallSize) {
      drawer.open({
        actionButton: null,
        backdropLink: null,
        footer: null,
        onClose: handleOnClose,
        placement: 'bottom',
        title: null,
        body: (
          <div className='bg-white w-screen px-4 pb-20'>
            <div className='py-6'>
              <Label
                text={currentStore.properties.name}
                weight='bold'
                size='lg'
              />
            </div>
            <div className='pb-4'>
              <Button
                type='contained'
                color={{ classname: 'primary' }}
                size='lg'
                label={{ text: directionLabel.text }}
                icon={{ iconKey: 'FaDirections', color: 'white' }}
                onClick={handleDirectionsClick}
              />
            </div>
            <div className='py-6 border-t border-b'>
              <Label text={currentStore.properties.address1} />
              <Label text={currentStore.properties.postcode} />
              <Label text={currentStore.properties.city} />
              {currentStore.properties.state && (
                <Label text={currentStore.properties.state} />
              )}
              <Label text={currentStore.properties.country} />
            </div>
          </div>
        ),
      });
    }
  }, [currentStore]);

  return (
    <>
      {currentStore && (
        <div className='p-6'>
          <div className='pb-6'>
            <Button
              type='white'
              icon={{ iconKey: 'HiOutlineReply' }}
              label={{ text: allVendorsLabel.text }}
              onClick={handleAllStoresClick}
            />
          </div>
          <div className='py-6 border-t border-b'>
            <Label
              text={currentStore.properties.name}
              weight='bold'
              size='lg'
            />
          </div>
          <div className='py-6 flex justify-between border-b'>
            <div>
              <Label text={currentStore.properties.address1} />
              <Label text={currentStore.properties.postcode} />
              <Label text={currentStore.properties.city} />
              <Label
                text={
                  currentStore.properties.state && currentStore.properties.state
                }
              />
              <Label text={currentStore.properties.country} />
            </div>
            <div className='flex items-center'>
              <Button
                type='contained'
                color={{ classname: 'primary' }}
                size='lg'
                label={{ text: directionLabel.text }}
                icon={{ iconKey: 'FaDirections', color: 'white' }}
                onClick={handleDirectionsClick}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
